"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const IconButton_1 = require("../IconButton");
const defaultButtonStyle = ({ theme }) => ({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore TODO: Figure out typings for themes (are themes even something we can/should share?)
    color: theme.palette.snackBarButton?.color,
});
const SnackbarAction = ({ message, buttonText, onClick, onClose, buttonStyle = defaultButtonStyle, }) => {
    const SnackBarButton = (0, material_1.styled)(material_1.Button)(buttonStyle);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        message,
        buttonText && (react_1.default.createElement(SnackBarButton, { size: "small", onClick: onClick }, buttonText)),
        react_1.default.createElement(IconButton_1.SnackbarIconButton, { size: "small", "aria-label": "close", color: "inherit", onClick: onClose },
            react_1.default.createElement(icons_material_1.Close, { fontSize: "small" }))));
};
exports.default = SnackbarAction;
